import momentTimezone from "moment-timezone";
import { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { useLocation, useNavigate } from "react-router-dom";
import { SyncLoader } from "react-spinners";
import Swal from "sweetalert2";

import { ShimmerTitle } from "react-shimmer-effects";
import { DropdownLokasi, DropdownShift, Header, Modal } from "../../components";
import { useAuth } from "../../context/AuthContext";
import { dashboardUrl, presensiUrl } from "../../helpers/ApiPresensi";
import { decryptLocalStorage } from "../../helpers/SecureStorage";
import { colors } from "../../utils";

const Presensi = () => {
  const data = useLocation();
  const tipe_presensi = data.state;
  const title =
    tipe_presensi === "masuk" ? "Presensi Masuk" : "Presensi Pulang";

  const token = decryptLocalStorage(process.env.REACT_APP_LOCAL_STORAGE_TOKEN);
  const navigate = useNavigate();

  const now = new Date();
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const time = `${hours}:${minutes}`;

  const { logout } = useAuth();
  const [location, setLocation] = useState({ lat: null, long: null });
  const [isLoading, setIsLoading] = useState(false);
  const [shiftList, setShiftList] = useState([]);
  const [lokasiList, setLokasiList] = useState([]);
  const [jumlahShift, setJumlahShift] = useState(0);
  const [jumlahLokasi, setJumlahLokasi] = useState(0);
  const [distance, setDisatance] = useState(0);
  const [selectedLokasi, setSelectedLokasi] = useState(null);
  const [selectedShift, setSelectedShift] = useState(null);
  const [labelinfo, setLabelinfo] = useState("Presensi");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [photo, setphoto] = useState(null);
  const [keterangan, setketerangan] = useState("");
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  let stream;

  const openCamera = async () => {
    stream = await navigator.mediaDevices.getUserMedia({
      video: { facingMode: "environment" },
    });
    videoRef.current.srcObject = stream;
  };

  const stopCamera = () => {
    if (videoRef.current?.srcObject) {
      videoRef.current.srcObject.getTracks().forEach((t) => t.stop());
    }
  };

  const capture = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    const ctx = canvas.getContext("2d");
    ctx.drawImage(video, 0, 0);

    canvas.toBlob(
      (blob) => {
        // Generate nama random: timestamp + 5 digit random
        const randomSuffix = Math.floor(Math.random() * 100000); // 0 - 99999
        const fileName = `bukti_telat_${Date.now()}_${randomSuffix}.jpg`;

        const file = new File([blob], fileName, {
          type: "image/jpeg",
        });

        stopCamera();
        setphoto(file); // simpan di state
      },
      "image/jpeg",
      0.8,
    );
  };

  const calculateDistance = (latitude1, longitude1, latitude2, longitude2) => {
    // Convert degrees to radians
    const toRadians = (degree) => degree * (Math.PI / 180);

    const lat1 = toRadians(latitude1);
    const lon1 = toRadians(longitude1);
    const lat2 = toRadians(latitude2);
    const lon2 = toRadians(longitude2);

    // Earth radius in meters
    const earthRadius = 6371000; // 6371 km

    // Haversine formula
    const dLat = lat2 - lat1;
    const dLon = lon2 - lon1;
    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = earthRadius * c;

    // const jarak = distance.toFixed(2);

    const jarak = distance;

    return jarak;
  };

  const formatNumber = (number) => {
    return number.toLocaleString("id-ID", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  };

  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    },
  });

  const getDashboard = async () => {
    try {
      setIsLoading(true);

      const response = await fetch(dashboardUrl, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Network error");
      }

      const result = await response.json();

      if (result.data.shift) {
        setShiftList(result.data.shift);
        setSelectedShift(result.data.shift[0].id_presensi);

        setLabelinfo(
          `Waktu presensi ${tipe_presensi} adalah ${
            tipe_presensi === "masuk" ? "sebelum" : ""
          } jam ${
            tipe_presensi === "masuk"
              ? result.data.shift[0].masuk_batas_akhir
              : result.data.shift[0].pulang_batas_awal
          }`,
        );

        setJumlahShift(result.data.shift.length);
      }

      if (result.data.lokasi) {
        setLokasiList(result.data.lokasi);

        setSelectedLokasi(result.data.lokasi[0].setting_id);

        setJumlahLokasi(result.data.lokasi.length);
      }
    } catch (error) {
      // console.log(error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const newLocation = {
            lat: position.coords.latitude,
            long: position.coords.longitude,
          };

          setLocation(newLocation);

          // console.log(newLocation);
        },
        (error) => {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Perangkat ini tidak memberikan izin lokasi",
            willClose: () => {
              window.open("/home", "_blank");
            },
          });
        },
      );
    } else {
      const errorMsg = "Perangkat ini tidak mendukung geolocation";
      Swal.fire({
        icon: "error",
        title: "Error",
        text: errorMsg,
        willClose: () => {
          window.open("/home", "_blank");
        },
      });
    }
  }, []);

  useEffect(() => {
    getDashboard();
  }, []);

  useEffect(() => {
    const lokasi = lokasiList.find(
      (item) => item.setting_id === selectedLokasi,
    );

    if (lokasi) {
      const calDisatance = calculateDistance(
        location.lat,
        location.long,
        lokasi.latitude,
        lokasi.longitude,
      );

      // console.log(calDisatance);

      setDisatance(calDisatance);
    }
  }, [lokasiList, selectedLokasi, location.lat, location.long]);

  useEffect(() => {
    const shift = shiftList.find((item) => item.id_presensi === selectedShift);

    if (shift) {
      setLabelinfo(
        `Waktu presensi ${tipe_presensi} adalah ${
          tipe_presensi === "masuk" ? "sebelum" : ""
        } jam ${
          tipe_presensi === "masuk"
            ? shift.masuk_batas_akhir
            : shift.pulang_batas_awal
        }`,
      );
    }
  }, [selectedShift, shiftList, tipe_presensi]);

  // PRESENSI
  const prapresensikan = async () => {
    const shift = shiftList.find((item) => item.id_presensi === selectedShift);

    const now = momentTimezone().tz("Asia/Jakarta");
    const format = "HH:mm:ss";
    const jam_sekarang = momentTimezone(now.format(format), format);

    let status_presensi = "TEPAT";

    if (tipe_presensi === "masuk") {
      const masuk_batas_akhir = momentTimezone(
        shift.masuk_batas_akhir,
        format,
      ).tz("Asia/Jakarta");

      if (jam_sekarang.isAfter(masuk_batas_akhir)) {
        status_presensi = "TELAT";
        setIsModalOpen(true); // buka modal untuk ambil foto
        // return; // tunggu user ambil foto dulu
      } else {
        presensikan(status_presensi);
      }
    } else {
      presensikan(status_presensi);
    }
  };

  const onPresensiTelat = () => {
    if (photo == null) {
      Toast.fire({
        icon: "error",
        title: "Foto bukti terlambat wajib diisi",
      });
      return;
    }
    let statusfix = "TELAT";
    presensikan(statusfix);
  };

  const presensikan = async (status_presensi) => {
    const lokasi = lokasiList.find(
      (item) => item.setting_id === selectedLokasi,
    );

    const now = momentTimezone().tz("Asia/Jakarta");
    const format = "HH:mm:ss";

    if (distance > lokasi.radius) {
      Toast.fire({
        icon: "error",
        title: "Kamu di luar radius",
      });
      return;
    }

    setIsLoading(true);

    try {
      let payload;

      const baseData = {
        id_presensi: selectedShift,
        jenis_presensi: "REGULER",
        tipe_presensi: tipe_presensi,
        status_kehadiran: status_presensi,
        id_lokasi: selectedLokasi.toString(),
        latitude: location.lat.toString(),
        longitude: location.long.toString(),
        keterangan: keterangan,
      };
      // Kalau TELAT dan ada foto
      if (status_presensi === "TELAT" && photo) {
        payload = new FormData();

        // Append semua data
        Object.keys(baseData).forEach((key) => {
          payload.append(key, baseData[key]);
        });

        // Append foto
        payload.append("bukti_telat", photo); // photo = File dari canvas
      } else {
        // Kalau tidak telat, kirim JSON biasa
        payload = JSON.stringify(baseData);
      }

      const response = await fetch(presensiUrl, {
        method: "POST",
        mode: "cors",
        headers: {
          Authorization: `${token}`,
          ...(status_presensi !== "TELAT" && {
            "Content-Type": "application/json",
          }),
          // Jangan set Content-Type kalau FormData, browser otomatis set boundary
        },
        body: payload,
      });

      if (!response.ok) {
        let errorMessage = "Gagal presensi";

        if (response.status === 401) {
          logout();
        } else if (response.status === 409) {
          // Conflict, user sudah presensi
          errorMessage = "Kamu sudah melakukan presensi di shift ini";
        } else {
          // Coba parse JSON kalau bisa
          try {
            const data = await response.json();
            errorMessage = data.message || errorMessage;
          } catch (err) {
            // Kalau gagal parse JSON, tetap pakai errorMessage default
          }
        }

        Toast.fire({
          icon: response.status === 409 ? "warning" : "error",
          title: errorMessage,
        });

        setIsLoading(false);
        return;
      }

      // Kalau ok, parse JSON
      // const data = await response.json();
      Toast.fire({
        icon: "success",
        title: "Presensi berhasil",
      });

      // Reset atau navigasi
      setIsLoading(false);
      setphoto(null);
      setIsModalOpen(false);
      navigate("/home");
    } catch (error) {
      Toast.fire({
        icon: "error",
        title: "Terjadi kesalahan saat presensi",
      });
      setIsLoading(false);
    }
  };

  return (
    <div>
      {location.lat && location.long ? (
        <div className="flex flex-col min-h-screen overflow-x-hidden">
          <Helmet>
            <title>Presensi</title>
          </Helmet>

          <div
            className="flex-grow"
            style={{ backgroundColor: colors.whitegrey }}
          >
            <div
              className="w-full py-8 items-start"
              style={{
                height: 130,
                backgroundColor: colors.orange,
              }}
            ></div>

            <div className="lg:mx-8" style={{ marginTop: -120 }}>
              <div className="p-4" style={{ borderRadius: 12 }}>
                <Header to="/home" title={title} />

                {isLoading ? (
                  <LoadingWidget />
                ) : (
                  <div
                    className="p-4 bg-white mt-4 shadow-md"
                    style={{ borderRadius: 12, borderColor: colors.orange }}
                  >
                    <h5
                      className="rounded-full px-4 py-2 font-thin text-xs text-center mb-4"
                      style={{ backgroundColor: colors.whitegrey }}
                    >
                      {labelinfo}
                    </h5>

                    <div className="flex row-auto items-center justify-between mb-4">
                      <h5 className="text-left font-semibold tracking-tight text-sm">
                        Waktu Presensi
                      </h5>
                      <h5 className="font-light tracking-tight text-sm">
                        {time}
                      </h5>
                    </div>

                    <div className="flex row-auto items-center justify-between mb-4">
                      <h5 className="text-left font-semibold tracking-tight text-sm">
                        Jarak
                      </h5>
                      <h5 className="font-light tracking-tight text-sm">
                        {formatNumber(distance)} meter{" "}
                      </h5>
                    </div>

                    <h5 className="text-left font-semibold tracking-tight text-sm mb-4">
                      Lokasi
                    </h5>

                    {jumlahLokasi > 0 ? (
                      <DropdownLokasi
                        options={lokasiList}
                        onChange={setSelectedLokasi}
                        type="lokasi"
                      />
                    ) : (
                      <p className="text-xs">Tidak ada lokasi</p>
                    )}

                    <h5 className="text-left font-semibold tracking-tight text-sm my-4">
                      Shift
                    </h5>

                    {jumlahShift > 0 ? (
                      <DropdownShift
                        options={shiftList}
                        onChange={setSelectedShift}
                      />
                    ) : (
                      <p className="text-xs">Tidak ada shift</p>
                    )}

                    {jumlahLokasi > 0 && jumlahShift > 0 ? (
                      <button
                        onClick={prapresensikan}
                        className="px-4 py-2 rounded-full w-full text-white mt-4"
                        style={{ backgroundColor: colors.orange }}
                      >
                        Presensi
                      </button>
                    ) : (
                      <div></div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
            <video
              ref={videoRef}
              autoPlay
              playsInline
              style={{ width: "100%", borderRadius: 8 }}
            />
            <canvas ref={canvasRef} style={{ display: "none" }} />
            <div className="mt-4">
              <label
                for="keterangan"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Keterangan
              </label>
              <div className="mt-1">
                <input
                  value={keterangan}
                  onChange={(e) => setketerangan(e.target.value)}
                  id="keterangan"
                  name="keterangan"
                  type="text"
                  placeholder="Masukkan Keterangan"
                  autocomplete="text"
                  className="px-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div
              style={{
                marginTop: 20,
                display: "flex",
                justifyContent: "space-between",
                gap: 10, // jarak antar button
              }}
            >
              <button
                onClick={openCamera}
                style={{
                  flex: 1,
                  padding: "10px 20px",
                  backgroundColor: "#6c757d", // abu-abu
                  color: "white",
                  border: "none",
                  borderRadius: 8,
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
              >
                Buka Kamera
              </button>

              <button
                onClick={capture}
                style={{
                  flex: 1,
                  padding: "10px 20px",
                  backgroundColor: "#28a745", // hijau
                  color: "white",
                  border: "none",
                  borderRadius: 8,
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
              >
                Ambil Foto Sekarang
              </button>
            </div>

            <button
              onClick={onPresensiTelat}
              style={{
                marginTop: 15,
                width: "100%",
                padding: "10px 20px",
                backgroundColor: "#FFA500", // orange
                color: "white",
                border: "none",
                borderRadius: 8,
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              Presensi
            </button>
            <button
              onClick={() => setIsModalOpen(false)}
              style={{
                marginTop: 15,
                width: "100%",
                padding: "10px 20px",
                backgroundColor: "#dc3545", // merah
                color: "white",
                border: "none",
                borderRadius: 8,
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              Batal
            </button>
          </Modal>
        </div>
      ) : (
        <ShimmerLoading />
      )}
    </div>
  );
};

const LoadingWidget = () => {
  return (
    <div
      className="p-4 bg-white mt-4 shadow-md h-96 flex flex-col items-center justify-center"
      style={{ borderRadius: 12, borderColor: colors.orange }}
    >
      <SyncLoader size={8} speedMultiplier={0.6} color={colors.orange} />
      <div
        className="mt-4 tracking-widest text-md italic"
        style={{ color: colors.orange }}
      >
        Loading ...
      </div>
    </div>
  );
};

const ShimmerLoading = () => {
  return (
    <div className="flex flex-col min-h-screen overflow-x-hidden">
      <Helmet>
        <title>Presensi</title>
      </Helmet>

      <div className="flex-grow" style={{ backgroundColor: colors.whitegrey }}>
        <div
          className="w-full py-8 items-start"
          style={{
            height: 130,
            backgroundColor: colors.orange,
          }}
        ></div>

        <div className="lg:mx-8" style={{ marginTop: -120 }}>
          <div className="p-4" style={{ borderRadius: 12 }}>
            <Header to="/home" title="Presensi Masuk" />

            <div
              className="p-4 bg-white mt-4 shadow-md"
              style={{ borderRadius: 12, borderColor: colors.orange }}
            >
              <ShimmerTitle line={1} gap={10} variant="primary" />

              <ShimmerTitle line={1} gap={10} variant="primary" />

              <ShimmerTitle line={1} gap={10} variant="primary" />

              <ShimmerTitle line={1} gap={10} variant="primary" />

              <ShimmerTitle line={1} gap={10} variant="primary" />

              <ShimmerTitle line={1} gap={10} variant="primary" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Presensi;
